













































import Vue from 'vue';
import firstCharsToUpperCase from '@/util/firstCharsToUpperCase';

export default Vue.extend({
  props: {
    optionsInit: Object,
    recibosInit: Array,
    disabled: Boolean,
  },
  data: () => ({
    openDialog: false,
    recibos: [],
    headers: [
      { text: 'Unidad', value: 'unidad.name' },
      { text: 'Periodo', value: 'periodo' },
      { text: 'Propietario', value: 'propietario.nombre' },
      // { text: 'Recibo ID', value: 'id' },
      { text: 'Conceptos', value: 'items.length', sortable: false },
      { text: 'Subtotal', value: 'subtotal', sortable: false },
      { text: 'Monto Total', value: 'total', sortable: false },
    ],
    options: {},
    total: 0,
    precision: 2,
  }),
  methods: {
    closeDialog() {
      this.openDialog = false;
    },
    async GenerarRecibos() {
      for (const recibo of this.recibos) {
        recibo.creationDateTime = this.$moment().format();
        recibo.creationUsername = this.$store.getters.getUsername;
        recibo.pagoStatus = 'NOPAGADO';
      }
      try {
        const admin = this.$store.getters.getAdmin;
        const condo = this.$store.getters.getCondo;
        const recibos = this.recibos;
        const datos = {admin, condo, recibos};
        console.log('addLoteRecibos datos: %o', datos);
        const response = await this.$store.dispatch('addLoteRecibos', {admin, condo, recibos});
        console.log('addLoteRecibos response: %o', response);
        this.$toast.success('Recibos agregados exitosamente');
      } catch (e) {
        console.error(e);
        this.$toast.error(e.response.data.message);
      }
      this.closeDialog();
      this.$emit('reload', {});
    },
    periodo(item) {
      const fecha = this.$moment(item.periodo).format('MMMM YYYY');
      return firstCharsToUpperCase(fecha);
    },
  },
  watch: {
    openDialog() {
      if (this.openDialog) {
        this.recibos = JSON.parse(JSON.stringify(this.recibosInit));
        this.options = JSON.parse(JSON.stringify(this.optionsInit));
        this.total = this.recibos.length;
      } else {
        this.recibos = [];
      }
    },
  },
});
